<template>
  <div class="bg-neutral-300 shadow rounded overflow-hidden">
    <div class="flex flex-col p-8">
      <Lynx-Title text="Solicitação"/>

      <form class="flex items-end" @submit.prevent="selectEmpresa()">
        <label class="flex flex-col w-64">
          <Lynx-Label label="Número da Empresa"/>

          <Lynx-Input
            v-model="empresaId"
            placeholder="Digite o número da empresa"
            type="number" required
          />
        </label>

        <Lynx-Button style="color:white;" type="submit" size="small" text="Confirmar" icon="ArrowRight"/>
      </form>

      <div v-if="empresa" class="mt-8">
        <p class="text-xl font-display mb-4">
          {{ empresa.razao_social }} / {{ empresa.endereco.uf }}
        </p>

        <label class="flex flex-col w-96 mb-4">
          <Lynx-Label label="Tipo de Alteração"/>

          <b-select  v-model="form.tipo" placeholder="Selecione o tipo de alteração">
            <option :value="1">Alvará Funcionamento</option>
            <option :value="2">Alvará bombeiro</option>
            <option :value="3">Alvará vigilãncia</option>
            <option :value="4">Alvará de meio ambiente</option>


          </b-select>
        </label>


        <label class="flex flex-col w-2/3 mb-4">
          <Lynx-Label label="Observação"/>
          <Textarea v-model="form.descricao"/>
        </label>
      </div>
    </div>

    <div class="bg-neutral-400 border-neutral-500 border-t p-8">
      <div v-if="empresa" class="flex">
        <div class="flex-1 mr-5">
         
          <!-- <p class="text-xl font-display">
            Valor Alteração: R$ {{ precoAlteracaoTotal }}
          </p> -->
        </div>
        <Lynx-Button @click.native.prevent="submitForm()" text="Realizar Solicitação Renovação" class=""/>
      </div>
    </div>
  </div>
</template>

<script>

import {AlvaraRenovacaoStore} from '@/services/requests/alvaraRenovacao'
import {empresasShowRequest} from '@/services/requests/empresas'

import Textarea from '@/components/helpers/Textarea'
import InputFile from '@/components/helpers/InputFile'

export default {
  name: 'AlvaraRenovacaoCreate',
  components: {Textarea, InputFile},
  data() {
    return {
      empresaId: null,
      empresa: null,
      form: {
       
          tipo: null,
          descricao: null,
          status: 1,

         
      },
      loading: false,
    }
  },


  methods: {
    selectEmpresa() {
      this.loading = true
      this.empresa = null
      empresasShowRequest(this.empresaId)
        .then(res => {
          this.empresa = res.data.data
        })
        .catch(() => this.$snack.error('Empresa não encontrada'))
        .finally(() => {
          this.loading = false
          this.fetchJuntaComercial()
        })
    },
  

    async submitForm() {
    

      const data = {...this.form}
      data.empresa_id = this.empresaId
      // data.solicitacao.preco_alteracao = this.precoAlteracaoTotal
      // data.solicitacao.preco_alteracao = 0.00


      AlvaraRenovacaoStore(data)
        .then(() => {
          this.$snack.success('Renovação solicitada com sucesso!')
          this.$emit('created')
        })
        .catch(error => {
          const errors = Object.values(error.response.data.errors)
          const message = errors.map(item => item.map(error => `<li>${error}</li>`).join('')).join('')

          this.$buefy.dialog.alert({
            title: 'Não foi possível solicitar a renovação',
            message: `<ul>${message}</ul>`,
            type: 'is-danger',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        })
        .finally(() => this.loading = false)
    },
  }
}
</script>
